/**
 * @module Component/AddToCart
 * @desc The AddToCart button
 */

export default {
  /**
   * @member {type} name tag name of the component
   * @readonly
   */
  name: 'addtocart',
  methods: {
    /**
     * on clic on addtocart button
     * @fires BasketEvents#BasketEvents AddItem
     */
    addtoCart: function () {
      this.emit(this.globalEvent.BasketEvent.ADD);
    },
  },
};
